class SourceErrorsService {
  constructor(httpDim, config) {
    this.httpDim = httpDim;
    this.config = config;
  }

  getErrors(batchId = 'last') {
    let url = `${this.config.apiRoot}/batches/${batchId}/sourceErrors`;
    return this.httpDim.get(url, this.config);
  }

  getSourceFileErrors(source) {
    let config = this.config;
    let batchId = source.batchId;
    let fileName = source.fileName;

    let url = `${this.config.apiRoot}/batches/${batchId}/sourceFiles/${fileName}/sourceErrors`;

    return this.httpDim.get(url, config);
  }
}

SourceErrorsService.$inject = ['httpDim', 'config'];
export
default SourceErrorsService;



// WEBPACK FOOTER //
// ./app/common/sourceErrors/sourceErrors.service.js